module.exports = __webpack_public_path__ + "2d2f6148adedfd8ba0a5997815236377.jpg";